// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-2ca564c4] {\n  fill: #1A7BEE;\n}\n.st3[data-v-2ca564c4] {\n  fill: #a1e7fc;\n}\n.st4[data-v-2ca564c4] {\n  fill: #fff;\n}\n.st8[data-v-2ca564c4] {\n  fill: none;\n  stroke: #428dfc;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-miterlimit: 10;\n}\n.st9[data-v-2ca564c4] {\n  fill: #23286b;\n}\n.st11[data-v-2ca564c4] {\n  fill: #eee;\n}\n", ""]);
// Exports
module.exports = exports;
